<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Analisis atendidos</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card>
            <v-container fluid>
              <v-row>
                <v-col cols="2">
                  <v-menu
                    v-model="menuFrom"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filters.from"
                        label="Desde"
                        readonly
                        clearable
                        v-on="on"
                        outlined
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filters.from"
                      @input="menuFrom = false"
                      no-title
                      locale="es"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="2">
                  <v-menu
                    v-model="menuUntil"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filters.until"
                        label="Hasta"
                        readonly
                        clearable
                        v-on="on"
                        outlined
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filters.until"
                      @input="menuUntil = false"
                      no-title
                      locale="es"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="3">
                  <v-autocomplete
                    v-model="filters.service_id"
                    :items="servicesList"
                    label="Analisis"
                    outlined
                    item-text="name"
                    item-value="id"
                    clearable
                    hide-details="auto"
                    :loading="isLoadingServices"
                    :search-input.sync="search_service"
                    v-on:keyup.enter="searchServicesList($event)"
                    hide-no-data
                    hide-selected
                    placeholder="Ingrese un analisis a buscar"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="3">
                  <v-autocomplete
                    v-model="filters.doctor_id"
                    :items="doctorsList"
                    label="Doctor"
                    hide-details
                    outlined
                    item-text="fullname"
                    item-value="id"
                    v-on:keyup.enter="searchDoctorList($event)"
                    clearable
                    :loading="isLoadingDoctors"
                    placeholder="Ingrese un doctor a buscar"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-btn color="blue" dark @click="searchServices">
                    Buscar
                  </v-btn>
                  <v-btn
                    color="green"
                    dark
                    class="ml-1"
                    :loading="processing"
                    @click="downloadServices"
                  >
                    Descargar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="services"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              fixed-header
            >
              <template v-slot:top>
                <span
                  class="ml-3 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table"
                  >Todas los servicios atendidos</span
                >
                <v-divider></v-divider>
              </template>

              <template v-slot:item.created_at="{ item }">
                <span>{{ item.created_at | moment("DD/MM/YYYY") }}</span>
              </template>

              <template v-slot:item.doctor_fullname="{ item }">
                <span v-if="item.doctor_fullname">{{
                  item.doctor_fullname
                }}</span>
                <span v-else>-</span>
              </template>

              <template v-slot:item.created_hour="{ item }">
                <span>{{ item.created_at | moment("hh:mm") }}</span>
              </template>

              <template v-slot:item.subtotal="{ item }">
                <span>{{ item.subtotal | currency("S/") }}</span>
              </template>

              <template v-slot:item.discount_value="{ item }">
                <span v-if="item.discount_value">
                  {{ item.discount_value | currency("S/") }}
                </span>
                <span v-else>
                  S/0.00
                </span>
              </template>

              <template v-slot:item.total="{ item }">
                <span v-if="item.discount_value">
                  {{ (item.subtotal - item.discount_value) | currency("S/") }}
                </span>
                <span v-else>
                  {{ item.subtotal | currency("S/") }}
                </span>
              </template>

              <template v-slot:item.is_bonus="{ item }">
                <span v-if="item.is_bonus">SI</span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";

import ServicesApi from "../../../apis/Services";
import DoctorsApi from "../../../apis/Doctors";

export default {
  name: "AttendedServices",
  components: {
    OfficeLogin,
  },
  data() {
    return {
      itemsBreadcrumbs: [
        {
          text: "Reportes",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "FECHA", value: "created_at", sortable: false, width: 100 },
        { text: "HORA", value: "created_hour", sortable: false, width: 70 },
        { text: "SERVICIO", value: "description", sortable: false, width: 310 },
        {
          text: "PACIENTE",
          value: "customer_fullname",
          sortable: false,
        },
        {
          text: "DOCTOR",
          value: "doctor_fullname",
          sortable: false,
        },
        { text: "CANTIDAD", value: "quantity", sortable: false, align: "end" },
        { text: "SUBTOTAL", value: "subtotal", sortable: false, align: "end" },
        {
          text: "DESCUENTO",
          value: "discount_value",
          sortable: false,
          align: "end",
        },
        { text: "TOTAL", value: "total", sortable: false, align: "end" },
        // { text: "TRABAJADOR", value: "fullname", sortable: false },

        { text: "GRATUITO", value: "is_bonus", sortable: false, width: 90 },
        { text: "NOTA", value: "note", sortable: false },
      ],
      processing: false,
      menuFrom: false,
      menuUntil: false,
      filters: {
        from: this.$moment().format("YYYY-MM-DD"),
        until: this.$moment().format("YYYY-MM-DD"),
        worker_id: null,
        service_id: null,
        doctor_id: null,
      },
      isLoading: false,
      search_service: null,
      services_api: [],
      servicesList: [],
      doctorsList: [],
      isLoadingServices: false,
      isLoadingDoctors: false,
    };
  },
  computed: {
    ...mapState("authentication", ["office_id"]),
    ...mapState("employees", ["workers"]),
    ...mapState("report-services", ["services", "file_name"]),
  },
  // watch: {
  //   async search_service(value) {
  //     if (value == null || value == undefined || value.length == 0) {
  //       return;
  //     }

  //     if (this.services_api.length > 0) {
  //       return;
  //     }

  //     if (this.isLoading) return;

  //     this.isLoading = true;

  //     let filters = {
  //       name: value,
  //     };
  //     ServicesApi.get_all(filters)
  //       .then((response) => {
  //         this.services_api = response.data;
  //       })
  //       .catch((error) => {
  //         // console.log(error);
  //       })
  //       .finally(() => (this.isLoading = false));
  //   },
  // },
  methods: {
    ...mapActions("employees", ["getWorkers"]),
    ...mapActions("report-services", [
      "getAttendedServices",
      "setServices",
      "downloadAttendedServices",
    ]),
    searchServices() {
      this.getAttendedServices(this.filters);
    },
    async downloadServices() {
      this.processing = true;
      let filters_data = Object.assign({}, this.filters);
      await this.downloadAttendedServices(filters_data);
      this.processing = false;
      if (this.file_name) {
        let url = process.env.VUE_APP_API_URL_BASE + "/" + this.file_name;
        window.open(url);
      }
    },
    async searchServicesList(value) {
      let filters = {};

      if (value?.target.value.length > 0)
        filters = { name: value.target.value };
      this.isLoadingServices = true;
      const response = await ServicesApi.get_allPaginated(filters);
      if (response.status == 200) {
        console.log(response);
        this.servicesList = response.data.data;
      }
      this.isLoadingServices = false;
    },
    async searchDoctorList(value) {
      let filters = {};

      if (value?.target.value.length > 0)
        filters = { fullname: value.target.value };
      this.isLoadingDoctors = true;
      const response = await DoctorsApi.get_allPaginated(filters);
      if (response.status == 200) {
        this.doctorsList = response.data.data;
      }
      this.isLoadingDoctors = false;
    },
  },
  created() {
    this.searchServices();
    this.searchServicesList(null);
    this.searchDoctorList(null);
    // this.getWorkers({
    //   office_id: this.office_id,
    // });
  },
  destroyed() {
    this.setServices([]);
  },
};
</script>

<style scoped></style>
